import React, { useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBold, faListUl, faTextHeight } from '@fortawesome/free-solid-svg-icons';
import { sanitizeProductDescriptionHtml } from '../productDescriptionFormat';
import './ProductDescriptionEditor.css';

const FONT_SIZE_BY_ACTION = {
    small: '2',
    normal: '3',
    large: '5',
};

export default function ProductDescriptionEditor({
    id = 'descripcion',
    name = 'descripcion',
    value,
    onChange,
    required = false,
    placeholder = 'Descripcion',
}) {
    const editorRef = useRef(null);
    const lastHtmlRef = useRef('');

    useEffect(() => {
        const safeHtml = sanitizeProductDescriptionHtml(value);

        if (editorRef.current && safeHtml !== lastHtmlRef.current) {
            editorRef.current.innerHTML = safeHtml || '';
            lastHtmlRef.current = safeHtml;
        }
    }, [value]);

    const emitChange = () => {
        if (!editorRef.current) {
            return;
        }

        const safeHtml = sanitizeProductDescriptionHtml(editorRef.current.innerHTML);
        lastHtmlRef.current = safeHtml;
        onChange(safeHtml);
    };

    const runCommand = (command, commandValue = null) => {
        if (!editorRef.current) {
            return;
        }

        editorRef.current.focus();
        document.execCommand(command, false, commandValue);
        emitChange();
    };

    const handlePaste = (event) => {
        event.preventDefault();
        const text = event.clipboardData.getData('text/plain');
        document.execCommand('insertText', false, text);
        emitChange();
    };

    return (
        <div className='descriptionEditor'>
            <div className='descriptionToolbar' aria-label='Formato de descripcion'>
                <button type='button' title='Negrita' onClick={() => runCommand('bold')}>
                    <FontAwesomeIcon icon={faBold} />
                </button>
                <button type='button' title='Lista con viñetas' onClick={() => runCommand('insertUnorderedList')}>
                    <FontAwesomeIcon icon={faListUl} />
                </button>
                <button type='button' title='Letra pequena' onClick={() => runCommand('fontSize', FONT_SIZE_BY_ACTION.small)}>
                    <FontAwesomeIcon icon={faTextHeight} />
                    <span>A-</span>
                </button>
                <button type='button' title='Letra normal' onClick={() => runCommand('fontSize', FONT_SIZE_BY_ACTION.normal)}>
                    <FontAwesomeIcon icon={faTextHeight} />
                    <span>A</span>
                </button>
                <button type='button' title='Letra grande' onClick={() => runCommand('fontSize', FONT_SIZE_BY_ACTION.large)}>
                    <FontAwesomeIcon icon={faTextHeight} />
                    <span>A+</span>
                </button>
            </div>
            <input type='hidden' id={id} name={name} value={value || ''} required={required} readOnly />
            <div
                ref={editorRef}
                className='descriptionEditorContent'
                contentEditable
                data-placeholder={placeholder}
                onInput={emitChange}
                onBlur={emitChange}
                onPaste={handlePaste}
                role='textbox'
                aria-multiline='true'
                suppressContentEditableWarning
            />
        </div>
    );
}
